const colorNeutralBlack = '#000';
const colorNeutralBlackRgb = '0 0 0';
const colorNeutralRegular = '#1f2328';
const colorNeutralRegularRgb = '31 35 40';
const colorNeutralLight1 = '#464f59';
const colorNeutralLight1Rgb = '70 79 89';
const colorNeutralLight2 = '#7e8b97';
const colorNeutralLight2Rgb = '126 139 151';
const colorNeutralLight3 = '#b9bfc6';
const colorNeutralLight3Rgb = '185 191 198';
const colorNeutralLight4 = '#dee1e4';
const colorNeutralLight4Rgb = '222 225 228';
const colorNeutralLight5 = '#f1f3f3';
const colorNeutralLight5Rgb = '241 243 243';
const colorNeutralWhite = '#fff';
const colorNeutralWhiteRgb = '255 255 255';
const colorBrandPrimaryDark1 = '#b85000';
const colorBrandPrimaryDark1Rgb = '184 80 0';
const colorBrandPrimaryRegular = '#ed6700';
const colorBrandPrimaryRegularRgb = '237 103 0';
const colorBrandPrimaryLight1 = '#ff913d';
const colorBrandPrimaryLight1Rgb = '255 145 61';
const colorBrandPrimaryLight2 = '#fff3eb';
const colorBrandPrimaryLight2Rgb = '255 243 235';
const colorBrandSecondaryDark1 = '#12579b';
const colorBrandSecondaryDark1Rgb = '18 87 155';
const colorBrandSecondaryRegular = '#1976d2';
const colorBrandSecondaryRegularRgb = '25 118 210';
const colorBrandSecondaryLight1 = '#4a9ff2';
const colorBrandSecondaryLight1Rgb = '74 159 242';
const colorBrandSecondaryLight2 = '#e4f0fc';
const colorBrandSecondaryLight2Rgb = '228 240 252';
const colorContextualErrorDark1 = '#b60000';
const colorContextualErrorDark1Rgb = '182 0 0';
const colorContextualErrorRegular = '#d60000';
const colorContextualErrorRegularRgb = '214 0 0';
const colorContextualErrorLight1 = '#ff0a0a';
const colorContextualErrorLight1Rgb = '255 10 10';
const colorContextualErrorLight2 = '#ffebeb';
const colorContextualErrorLight2Rgb = '255 235 235';
const colorContextualSuccessDark1 = '#106105';
const colorContextualSuccessDark1Rgb = '16 97 5';
const colorContextualSuccessRegular = '#168806';
const colorContextualSuccessRegularRgb = '22 136 6';
const colorContextualSuccessLight1 = '#26b413';
const colorContextualSuccessLight1Rgb = '38 180 19';
const colorContextualSuccessLight2 = '#e4ffe0';
const colorContextualSuccessLight2Rgb = '228 255 224';
const colorContextualWarningDark1 = '#856900';
const colorContextualWarningDark1Rgb = '133 105 0';
const colorContextualWarningRegular = '#ffc900';
const colorContextualWarningRegularRgb = '255 201 0';
const colorContextualWarningLight1 = '#ffda52';
const colorContextualWarningLight1Rgb = '255 218 82';
const colorContextualWarningLight2 = '#fff4cc';
const colorContextualWarningLight2Rgb = '255 244 204';
const colorContextualInfoDark1 = '#0a6171';
const colorContextualInfoDark1Rgb = '10 97 113';
const colorContextualInfoRegular = '#0d8296';
const colorContextualInfoRegularRgb = '13 130 150';
const colorContextualInfoLight1 = '#10a2bc';
const colorContextualInfoLight1Rgb = '16 162 188';
const colorContextualInfoLight2 = '#e3f9fd';
const colorContextualInfoLight2Rgb = '227 249 253';
const spacingXxsmall = '4px';
const spacingXsmall = '8px';
const spacingSmall = '12px';
const spacingBase = '16px';
const spacingMedium = '20px';
const spacingLarge = '24px';
const spacingXlarge = '28px';
const spacingXxlarge = '32px';
const spacingXxxlarge = '40px';
const spacingXxxxlarge = '48px';
const spacingGiant = '64px';
const spacingXgiant = '80px';
const screenXs = '576px';
const screenSm = '768px';
const screenMd = '992px';
const screenLg = '1200px';
const screenXlg = '1440px';
const screenFhd = '1920px';
const screen2k = '2048px';
const screen4k = '3840px';
const screenMaxContainer = '1136px';
const fontFamily = '"Roboto", sans-serif';
const fontWeightRegular = '400';
const fontWeightBold = '700';
const borderRadius = '4px';
const borderRadiusMedium = '8px';
const borderRadiusLarge = '12px';
const borderRadiusFull = '50%';
const zindex1 = '1';
const zindex5 = '5';
const zindex10 = '10';
const zindex100 = '100';
const zindex1000 = '1000';
const zindexOverlay = '10000';
const transitionDuration = '0.25s';

export { borderRadius, borderRadiusFull, borderRadiusLarge, borderRadiusMedium, colorBrandPrimaryDark1, colorBrandPrimaryDark1Rgb, colorBrandPrimaryLight1, colorBrandPrimaryLight1Rgb, colorBrandPrimaryLight2, colorBrandPrimaryLight2Rgb, colorBrandPrimaryRegular, colorBrandPrimaryRegularRgb, colorBrandSecondaryDark1, colorBrandSecondaryDark1Rgb, colorBrandSecondaryLight1, colorBrandSecondaryLight1Rgb, colorBrandSecondaryLight2, colorBrandSecondaryLight2Rgb, colorBrandSecondaryRegular, colorBrandSecondaryRegularRgb, colorContextualErrorDark1, colorContextualErrorDark1Rgb, colorContextualErrorLight1, colorContextualErrorLight1Rgb, colorContextualErrorLight2, colorContextualErrorLight2Rgb, colorContextualErrorRegular, colorContextualErrorRegularRgb, colorContextualInfoDark1, colorContextualInfoDark1Rgb, colorContextualInfoLight1, colorContextualInfoLight1Rgb, colorContextualInfoLight2, colorContextualInfoLight2Rgb, colorContextualInfoRegular, colorContextualInfoRegularRgb, colorContextualSuccessDark1, colorContextualSuccessDark1Rgb, colorContextualSuccessLight1, colorContextualSuccessLight1Rgb, colorContextualSuccessLight2, colorContextualSuccessLight2Rgb, colorContextualSuccessRegular, colorContextualSuccessRegularRgb, colorContextualWarningDark1, colorContextualWarningDark1Rgb, colorContextualWarningLight1, colorContextualWarningLight1Rgb, colorContextualWarningLight2, colorContextualWarningLight2Rgb, colorContextualWarningRegular, colorContextualWarningRegularRgb, colorNeutralBlack, colorNeutralBlackRgb, colorNeutralLight1, colorNeutralLight1Rgb, colorNeutralLight2, colorNeutralLight2Rgb, colorNeutralLight3, colorNeutralLight3Rgb, colorNeutralLight4, colorNeutralLight4Rgb, colorNeutralLight5, colorNeutralLight5Rgb, colorNeutralRegular, colorNeutralRegularRgb, colorNeutralWhite, colorNeutralWhiteRgb, fontFamily, fontWeightBold, fontWeightRegular, screen2k, screen4k, screenFhd, screenLg, screenMaxContainer, screenMd, screenSm, screenXlg, screenXs, spacingBase, spacingGiant, spacingLarge, spacingMedium, spacingSmall, spacingXgiant, spacingXlarge, spacingXsmall, spacingXxlarge, spacingXxsmall, spacingXxxlarge, spacingXxxxlarge, transitionDuration, zindex1, zindex10, zindex100, zindex1000, zindex5, zindexOverlay };
//# sourceMappingURL=index.mjs.map
